export const SLUG_PATTERNS = {
  'u': { pattern: new RegExp('[a-z0-9-]') }
};
